import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
};
export default (state = initState, action) => {
  switch (action.type) {
    case actions.SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORDS:
    case actions.SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORDS_ENDED:
    case actions.SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORD_LOGS:
    case actions.SEARCH_SYNCHRONIZED_UPLOAD_TRANSACTION_RECORD_LOGS_ENDED:
    default:
      return state;
  }
};
